import "@adyen/adyen-web/dist/adyen.css";
import R from "@adyen/adyen-web";
import * as b from "ably";
import { getAdapter as E } from "../../../reactive/features/api/adapter.js";
import { AdyenEngineConfigAdapter as S } from "../../../reactive/features/api/models/payment/adyen/adyenEngineConfig/adyenEngineConfig.adapter.js";
import { EventDispatcher as T } from "../../events/eventDispatcher.js";
import { AdyenGPayPaymentMethod as w } from "../../../reactive/features/api/models/payment/adyen/adyenPaymentMethod/adyenGPayPaymentMethod/adyenGPayPaymentMethod.model.js";
import { AdyenApplePaymentMethod as I } from "../../../reactive/features/api/models/payment/adyen/adyenPaymentMethod/adyenApplePayPaymentMethod/adyenApplePayPaymentMethod.model.js";
import { AsyncAPI as v } from "../../async.js";
import { HIDEN_FRAME_METHODS as C } from "../../../reactive/features/payments/payment.types.js";
import { PaymentAPI as s } from "../paymentApi.js";
import { PaymentProcessAPI as _ } from "../paymentProcess.js";
import { PaymentUtils as N } from "../paymentUtils.js";
class F extends _.PaymentProcess {
  constructor(t) {
    super({
      ...t,
      engine: s.PaymentMethodEngine.ADYEN,
      engineConfigAdapter: E(S)
    }), this.eventDispatcher = new T();
  }
  updateEngineAmount(t) {
    if (!this.checkout)
      return;
    const e = this.getAdyenConfig();
    e !== null && this.checkout.update(e);
  }
  async afterInitialize(t) {
    this.checkout = await R({
      ...this.getAdyenConfig(),
      onError: (e) => this.eventDispatcher.dispatch("onError", e),
      onSubmit: (e, n) => this.eventDispatcher.dispatch("onSubmit", [e, n]),
      onChange: (e, n) => this.eventDispatcher.dispatch("onChange", [e, n]),
      onAdditionalDetails: (e) => this.eventDispatcher.dispatch("onAdditionalDetails", [e])
    });
  }
  getAdyenConfig() {
    if (!this.engineConfig)
      return null;
    const t = this.engineConfig.paymentMethods.find((i) => i instanceof w), e = this.engineConfig.paymentMethods.find((i) => i instanceof I), n = this.engineConfig.paymentMethods.filter((i) => i instanceof w ? this.configuration.method === s.PaymentMethodType.GOOGLE_PAY : i instanceof I ? this.configuration.method === s.PaymentMethodType.APPLE_PAY : i.type === "paybybank" ? this.configuration.method === s.PaymentMethodType.ADYEN_PAY_BY_BANK : this.configuration.method === s.PaymentMethodType.CREDIT_CARD), o = this.configuration.method === s.PaymentMethodType.CREDIT_CARD ? this.engineConfig.storedMethods : [];
    return {
      environment: this.engineConfig.environment,
      clientKey: this.engineConfig.clientKey,
      paymentMethodsResponse: {
        paymentMethods: n,
        storedPaymentMethods: o
      },
      amount: {
        currency: this.configuration.currency,
        value: this.configuration.amount + this.configuration.tip - this.configuration.cashback
      },
      locale: this.configuration.locale,
      paymentMethodsConfiguration: {
        paybybank: {
          showImage: !0
        },
        storedCard: {
          hideCVC: !0,
          enableStoreDetails: !0
        },
        card: {
          enableStoreDetails: !0,
          hasHolderName: !0,
          holderNameRequired: !0
        },
        googlepay: {
          configuration: {
            gatewayMerchantId: (t == null ? void 0 : t.configuration.gatewayMerchantId) ?? "",
            merchantId: t == null ? void 0 : t.configuration.merchantId,
            merchantName: t == null ? void 0 : t.configuration.merchantName,
            merchantOrigin: t == null ? void 0 : t.configuration.merchantOrigin,
            authJwt: t == null ? void 0 : t.configuration.authJwt
          }
        },
        applepay: {
          configuration: {
            merchantId: e == null ? void 0 : e.configuration.merchantId,
            merchantName: e == null ? void 0 : e.configuration.merchantName
          }
        }
      }
    };
  }
  adaptAdyenSocketResponse(t) {
    return {
      action: t.action,
      transactionId: t.transaction_id,
      trackingUrl: t.tracking_url,
      tokenizedCard: {
        externalId: t.payment_method_id
        // cardBrand: data.card_brand,
        // pan: data.pan,
        // expirationDate: data.expiration_date,
        // userFullName: data.user_full_name,
      }
    };
  }
  connectToSocket(t) {
    const e = new b.Realtime(this.configuration.ablyApiKey), n = encodeURIComponent(t), o = e.channels.get(n);
    return new Promise((i, a) => {
      o.attach((r) => {
        r ? a(r) : i(o);
      });
    });
  }
  getSocketAction(t, e) {
    const n = new v.AsyncTask();
    return t.subscribe((o) => {
      const i = JSON.parse(o.data);
      e && i.ws_uuid !== e || (n.resolve(this.adaptAdyenSocketResponse(i)), t.detach());
    }), n;
  }
  timeoutLoop(t, e) {
    const n = {
      attempts: 1,
      currentTimeout: null,
      clear: () => {
        n.currentTimeout && (clearTimeout(n.currentTimeout), n.currentTimeout = null);
      }
    };
    function o() {
      n.currentTimeout = setTimeout(async () => {
        if (n.attempts !== t + 1) {
          try {
            await e();
          } catch (i) {
            console.error("Error inside timeout callback"), console.error(i);
          }
          n.attempts += 1, o();
        }
      }, 1e4 * 2 ** (n.attempts - 1));
    }
    return o(), n;
  }
  disableAdyenPaymentMethod(t, e, n) {
    super.disablePaymentMethod(t).then(() => e()).catch(() => n());
  }
  mount(t) {
    return new Promise((e) => {
      if (!this.checkout)
        throw new Error("Checkout is not ready");
      this.adyenDropin = this.checkout.create("dropin", {
        showPayButton: !1,
        showStoredPaymentMethods: !0,
        showRemovePaymentMethodButton: !0,
        onDisableStoredPaymentMethod: this.disableAdyenPaymentMethod.bind(this),
        onReady: () => {
          e();
        }
      }).mount(t), C.includes(this.configuration.method) && (t.style.display = "none");
    });
  }
  executePayment(t, e) {
    if (!this.adyenDropin)
      return Promise.reject(new Error("Dropin is not ready yet"));
    if (!this.adyenDropin.isValid && !N.isThirdPartyMethod(this.configuration.method))
      return Promise.reject(new Error("Invalid dropin state"));
    const n = new Promise((i) => {
      this.eventDispatcher.off("onAdditionalDetails").on("onAdditionalDetails", ([a]) => {
        i(a);
      });
    }), o = new Promise(
      (i, a) => {
        this.eventDispatcher.off("onError").on("onError", (r) => a(r)), this.eventDispatcher.off("onSubmit").on("onSubmit", async ([r, O]) => {
          var u, y, p, f, l;
          try {
            if (!this.engineConfig) {
              a(new Error("Engine config is not ready"));
              return;
            }
            const m = await this.connectToSocket(t.orderId), g = this.getSocketAction(m, t.wsUuid), P = {
              orderId: t.orderId,
              amount: this.configuration.amount,
              tip: this.configuration.tip,
              cashback: this.configuration.cashback,
              email: t.email,
              externalUserId: t.externalUserId,
              wsUuid: t.wsUuid,
              currency: this.configuration.currency,
              actions: t.actions,
              locationId: this.configuration.locationId,
              selectedItems: t.selectedItems,
              loyaltyId: t.loyaltyId,
              shopUrl: t.shopUrl,
              paymentMethods: [{
                methodType: this.configuration.method,
                engine: this.configuration.engine
              }],
              paymentMethodData: {
                ...r.data,
                ...r.data.origin ? { origin: r.data.origin } : { origin: window.location.origin }
              },
              storePaymentMethod: t.storePaymentMethod,
              countryCode: this.configuration.countryCode,
              shopOrderSource: this.configuration.shopOrderSource
            }, c = await this.paymentRepository.process(P), d = JSON.parse(
              JSON.stringify(P)
            );
            if (c.transactionId && (d.paymentMethodId = c.transactionId, delete d.paymentMethodData), c.action) {
              (u = e == null ? void 0 : e.onInteractionRequired) == null || u.call(e);
              let h = !1;
              try {
                (y = this.adyenDropin) == null || y.handleAction(c.action);
                const D = await n;
                (f = (p = D.data) == null ? void 0 : p.details) != null && f.threeDSResult && (d.paymentMethodData = {
                  paymentData: c.action.paymentData,
                  details: D.data.details
                });
              } finally {
                h || (h = !0, (l = e == null ? void 0 : e.onInteractionResolved) == null || l.call(e));
              }
            }
            await this.paymentRepository.confirmProcessPayment(d);
            const M = this.timeoutLoop(
              10,
              async () => {
                const h = await this.paymentRepository.validatePaymentTransaction({
                  shopOrderId: t.orderId,
                  wsUuid: t.wsUuid
                });
                g.resolve(
                  this.adaptAdyenSocketResponse(h)
                );
              }
            ), A = await g;
            if (M.clear(), A.action !== 1) {
              a(Error("Adyen payment form is not valid"));
              return;
            }
            i(A);
          } catch (m) {
            a(m);
          }
        });
      }
    );
    return o.catch((i) => {
      var a;
      (a = this.adyenDropin) == null || a.handleError({
        message: (i == null ? void 0 : i.message) ?? "",
        name: "ERROR",
        cause: "unknown"
      });
    }), this.adyenDropin.submit(), o;
  }
  async destroy() {
    var t;
    (t = this.adyenDropin) == null || t.remove(), this.adyenDropin = void 0;
  }
}
export {
  F as AdyenPaymentProcess
};
//# sourceMappingURL=adyen.process.js.map
